module.exports = __webpack_public_path__ + "img/about_5.bb57a552.jpg";